/*/ ## EF.Collections.SectionsCollection
//
// Collection for the survey sections */
(function(EF, undefined) {

  var SectionsCollection = Backbone.Collection.extend({
    model: EF.Models.Section
  });

  _.extend(EF.Collections, {
    SectionsCollection: SectionsCollection
  });

})(EF);

